import React from 'react';
import './CustomerOrderTableHeader.css';
import {FormattedMessage} from "react-intl";

const CustomerOrderTableHeader = (props) => {
    return (
        <div>
            {/*<div className="row">
                <div className="col-md-1">
                    <label className="view-user-info-label">#</label>
                </div>
                <div className="col-md-2">
                    <label className="view-user-info-label">
                        <FormattedMessage id="app.admin.user.order.id"
                                          defaultMessage="Order Id"
                                          description=""/>
                    </label>
                </div>
                <div className="col-md-2">
                    <label className="view-user-info-label">
                        <FormattedMessage id="app.admin.user.order.date"
                                          defaultMessage="Order Date"
                                          description=""/>
                    </label>
                </div>
                <div className="col-md-3">
                    <label className="view-user-info-label">
                        <FormattedMessage id="app.admin.user.order.shipping.address"
                                          defaultMessage="Shipping Address"
                                          description=""/>
                    </label>
                </div>
                <div className="col-md-2">
                    <label className="view-user-info-label">
                        <FormattedMessage id="app.order.history.header.status"
                                          defaultMessage="Status"
                                          description=""/>
                    </label>
                </div>
                <div className="col-md-2">
                    <label className="view-user-info-label">
                        <FormattedMessage id="app.order.history.table.action"
                                          defaultMessage="Actions"
                                          description=""/>
                    </label>
                </div>
            </div>*/}
            <div className="row row-resp">
                <div className="col-md-7 no-padding title-1 text-align-left responsive-userAddress-table">
                    {/*<FormattedMessage id="app.order.history.header.title"*/}
                                      {/*defaultMessage="Order History"*/}
                                      {/*description=""/>*/}
                                      <span className="font-size-order-table-header">注文履歴 &nbsp;</span>
                    <h6 className='display-text-order-table'>※ &nbsp;表示しております、基板イメージのレジスト色は全て緑で表示しています。</h6>
                </div>
                <div className="col-md-2 text-right no-padding text-center-responsive order-history-search-resp">
                    <FormattedMessage id="app.order.history.header.order-search"
                                      defaultMessage="Search by order number :"
                                      description=""/>
                </div>
                <div className="col-md-3 no-padding text-right text-center-responsive order-history-search-resp">
                    <input
                        className="order-search-bar"
                        type="text"
                        placeholder="Wxxxxxxxxxxxxxx"
                        name="search"
                        onChange={props.handleSearchChange}
                    />
                    {/*<button onClick={props.handleSearchChange}><i className="glyphicon glyphicon-search"></i></button>*/}
                </div>
                <div className="row responsive-userAddress-table-mobile">
                    <br/>
                </div>
            </div>
            <div className="row responsive-userAddress-table resp-history-separator">
            </div>

        </div>
    )
};

export default CustomerOrderTableHeader;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/CustomerOrderTableHeader/CustomerOrderTableHeader.js